import { render, staticRenderFns } from "./fangdaoPage.vue?vue&type=template&id=2635afc2&scoped=true"
import script from "./fangdaoPage.vue?vue&type=script&lang=js"
export * from "./fangdaoPage.vue?vue&type=script&lang=js"
import style0 from "./fangdaoPage.vue?vue&type=style&index=0&id=2635afc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2635afc2",
  null
  
)

export default component.exports